module.exports = __webpack_public_path__ + "img/11.d3ddb64d.png";